// import tingle from 'tingle.js';
// import ProductHelpers from './base';
import { newModalFromString } from '../components/modal';

let wishlist = require('./wishlistHeart');

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} productUrl - url to be used for going to the product details page
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
const fillModalElement = (productUrl, selectedValueUrl, modal) => {
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: html => {
            modal.setContent(html.renderedTemplate);
            if ($('.quickviewCarousel__wrapper').length) {
                $('.quickviewCarousel__slider').slick({
                    arrows: true,
                    prevArrow: $('.prev-button'),
                    nextArrow: $('.next-button'),
                    dots: false,
                    infinite: true,
                    draggable: false,
                    speed: 500,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 480,
                            settings: {
                                dots: true
                            }
                        }
                    ]
                }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    $('.quickviewCarousel__thumbnail').removeClass('active');
                    $('.quickviewCarousel__thumbnail').eq(nextSlide).addClass('active');
                });
                $('.quickviewCarousel__thumbnail').click(function () {
                    $('.quickviewCarousel__slider').slick('slickGoTo', $(this).index());
                });
            }
            wishlist.highlightIconsForAllItemsInWishlist();
            modal.open();
            $(modal.modalBox)
                .find('.close-custom')
                .on('click', function (e) {
                    modal.close();
                    modal.destroy();
                });

            const destroyModal = () => {
                modal.close();
                modal.destroy();
                // remove the event listener to manage cases where the modal
                // is opened two or more times, (removes console error)
                $(document).off('product:afterAddToCart', destroyModal);
            };
            window.modalTemp = modal;
            $(document).on('product:afterAddToCart', destroyModal);
        },
        error: err => {
            console.log('Error:', err);
        }
    });
};

/**
 * Add quick buy functionality from listing
 * @param {string} pid - product id
 * @param {string} promoId - promotion id for minicart carousel
 * @param {jQuery} $productContainer - DOM element
 */
const addToCartFromListing = (listingType, pid, promoId, $productContainer, isOrderAgainProduct = false) => {
    $.spinner().start();

    const GTMData = $productContainer.find('.analytics.productListingItem').data();

    var form = {
        pid: pid,
        quantity: 1,
        options: [],
        promoId: promoId,
        GTMItemListId: GTMData.item_list_id,
        GTMItemListName: GTMData.item_list_name,
        GTMIndex: GTMData.index,
        isOrderAgainProduct: isOrderAgainProduct
    };
    var url = $('#tileAddToCartUrl').data('url');
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form,
        success: function (response) {
            if (response) {
                $('.minicart .minicart-quantity').removeClass('hide');
                $('.minicart .minicart-quantity').text(response.quantityTotal);
                localStorage.setItem('lastClickedPosition', '');
                localStorage.setItem('listtype', 'listing');
                // $("body, html").animate({ scrollTop: 0 }, 500, 'swing');
                $('body').trigger('product:afterAddToCart', {
                    ...response,
                    listingType,
                    form,
                    $productContainer,
                    $analyticsContainer: $productContainer.find('.analytics').data()
                });
                response.form = form;
                $('body').trigger('count:update', response);
                if (response.newBonusDiscountLineItem &&
                    Object.keys(response.newBonusDiscountLineItem).length !== 0 &&
                    !response.newBonusDiscountLineItem.newBonusDiscountLineItemAutomaticallyAdded) {
                    chooseBonusProducts(response.newBonusDiscountLineItem);
                }

            } else {
                console.error('Ajax: Empty Response');
            }
            $.spinner().stop();
        },
        error: function (err) {
            console.error('ErrorCase: ' + err.message);
            $.spinner().stop();
        }
    });
};

const chooseBonusProducts = data => {
    // $('.modal-body').spinner().start();
    const bonusUrl = data.bonusChoiceRuleBased ? data.showProductsUrlRuleBased : data.showProductsUrlListBased;

    var htmlString = `
        <div class="modal-content bonus-product choose-bonus-product-dialog"
            id="chooseBonusProductModal"
            data-total-qty="${data.maxBonusItems}"
            data-UUID="${data.uuid}"
            data-pliUUID="${data.pliUUID}"
            data-addToCartUrl="${data.addToCartUrl}"
            data-pageStart="0"
            data-pageSize="${data.pageSize}"
            data-moreURL="${data.showProductsUrlRuleBased}"
            data-bonusChoiceRuleBased="${data.bonusChoiceRuleBased}">
            <div class="modal-header">
                <button type="button" class="js-confirm-bonus-products-back cc-back-custom hidden"><span aria-hidden="true"></span></button>
                <h4 class="">${data.labels.selectprods}</h4>
                <button type="button" class="close close-custom" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"></span></button>
            </div>
            <div class="modal-body"></div>
            <div class="modal-footer"></div>
            <div class="col-sm-12 text-center modal-footer-button">
                <button class="button btn-outline-primary col-12 col-sm-4 js-confirm-bonus-products" disabled>
                ${data.labels.confirm}
                </button>
            </div>
        </div>`;

    const modalContent = document.createElement('div');
    modalContent.innerHTML = htmlString;

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: rsp => {
            var parsedHtml = parseHtml(rsp.renderedTemplate);
            modalContent.querySelector('.modal-body').innerHTML = parsedHtml.body !== '' ? parsedHtml.body : rsp.renderedTemplate;
            modalContent.querySelector('.modal-footer').innerHTML = parsedHtml.footer ? parsedHtml.footer : '';
            if (parsedHtml.body === '') {
                modalContent.querySelector('.modal-footer-button').innerHTML = '';
            }
            const onPopupClose = () => {
                if (data.isTriggeredByCoupon) {
                    window.location.reload();
                }
            };
            const modal = newModalFromString(modalContent, false, ['bonus-product-modal', 'pdp-info-tingle-modal'], null, onPopupClose);

            $('.bonus-product-modal').addClass('bonus-modal--tezenis');
            $(modal.modalBox).addClass('rightModalAttribute');

            if ($('.page').data('action') === 'Cart-Show') {
                $('.bonus-product-item .quickviewCarousel__slider').slick({
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                });

                modal.open();
            } else {
                setTimeout(function () {
                    modal.open();
                    if ($('.product-quickview-bonus-product').length === 1 && $('.product-quickview-bonus-product').hasClass('product-master')) {
                        $('.product-quickview-bonus-product').find('.slider-values-container .color-variation .selectable').eq(0).trigger('click');
                    }
                    $('.bonus-product-item .quickviewCarousel__slider').slick({
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false
                    });
                }, 2000);
            }

            var bonusProductItems = $('.bonus-product-item');
            for (var i = 0; i < bonusProductItems.length; i++) {
                var bpi = bonusProductItems.eq(i);
                var openers = $(bpi).find('.js-panel-opener-free-gift');
                var colorLabel = $(bpi).find('.product-selection-label-color');
                if (colorLabel.length > 0 && openers.length > 1 && !$(colorLabel).hasClass('hidden')) {
                    $(openers.eq(1)).removeClass('js-panel-opener');
                }
            }
            $(modal.modalBox)
                .find('.close')
                .on('click', function (e) {
                    modal.close();
                });

            $('[data-dismiss="modal"]').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });
            _setupBonusProductsEventListeners();
            $('body').trigger('bonusProduct:quickviewOpen', { products: rsp.products, container: $(modal.modalBox).find('#chooseBonusProductModal') });
            $('.js-confirm-bonus-products').on('click', function (e) {
                e.preventDefault();
                let selectedBonusProductId = 'bonus_product_' + $('input[name="bonus-product-choice"]:checked').val();
                let $selectedBonusProduct = $('[id="' + selectedBonusProductId + '"]');

                if ($selectedBonusProduct.find('.slider-values-container .color-variation .selected').length > 0 &&
                    $selectedBonusProduct.find('.js-accordion-size-wrapper .sizes-container input:checked').length > 0) {
                    $selectedBonusProduct.find('.add-bonus-products').trigger('click');
                } else {
                    if ($selectedBonusProduct.find('.slider-values-container .color-variation .selected').length === 0) {
                        $selectedBonusProduct.find('.slider-values-container .color-variation .selectable').eq(0).trigger('click');
                    }
                    $('.bonus-product-item .product-quickview').hide();
                    $('.js-confirm-bonus-products').closest('.modal-footer-button').hide();
                    $selectedBonusProduct.removeClass('hidden');
                    $('.js-confirm-bonus-products-back').removeClass('hidden');
                    if ($selectedBonusProduct.hasClass('product-master')) {
                        $selectedBonusProduct.find('.add-bonus-products').addClass('disabled');
                    }
                }
            });
            $('.js-confirm-bonus-products-back').on('click', function (e) {
                let selectedBonusProductId = 'bonus_product_' + $('input[name="bonus-product-choice"]:checked').val();
                let $selectedBonusProduct = $('[id="' + selectedBonusProductId + '"]');
                $('.bonus-product-item .product-quickview').show();
                $('.js-confirm-bonus-products').closest('.modal-footer-button').show();
                $selectedBonusProduct.addClass('hidden');
                $('.js-confirm-bonus-products-back').addClass('hidden');
            });
            $('.choose-bonus-product-dialog .bonus-product-item .bonus-product-radio').on('change', function (e) {
                $('.js-confirm-bonus-products').removeAttr('disabled');
            });
        },
        error: () => {
            $.spinner().stop();
        }
    });
};
const parseHtml = html => {
    var $html = $('<div>').append($.parseHTML(html));

    var body = '';
    let $results = $html.find('.choice-of-bonus-product');
    for (let i = 0; i < $results.length; i++) {
        body += $results[i].outerHTML;
    }
    var footer = $html.find('.modal-footer').children().html();

    return {
        body: body,
        footer: footer
    };
};

const _setupBonusProductsEventListeners = () => {

    const enableBonusProductSelection = () => {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));
            var pid = response.product.id;
            $('button.select-bonus-product').data('pid', pid);
        });
    }

    const enableAddAfterBonusColorSelection = () => {
        $('body').on('change', '.bonus-product .choice-of-bonus-product,.bonus-product.choose-bonus-product-dialog', function () {
            if ($(this).find('.js-panel[data-attr="color"] .swatch-value').length === 0 ||
                $(this).find('.js-panel[data-attr="color"] .swatch-value.selected').length > 0) {
                $(this).find('.add-bonus-products').prop('disabled', false).removeClass('disabled');
            } else {
                $(this).find('.add-bonus-products').prop('disabled', true);
            }
        });
        $('body').on('click touchstart', '.bonus-product-item .color-variation', function () {
            var bpi = $(this).parents('.bonus-product-item');

            if (bpi.length > 0) {
                var openers = $(bpi).find('.js-panel-opener-free-gift');
                if (openers.length > 1) {
                    $(openers.eq(1)).addClass('js-panel-opener');
                }

                if ($(bpi).find('.js-panel[data-attr="size"] input[type="radio"]').length === 0
                    || $(bpi).find('.js-panel[data-attr="size"] input[type="radio"]:checked').length) {
                    $(bpi).find('.add-bonus-products').removeAttr('disabled');
                } else {
                    $(bpi).find('.add-bonus-products').prop('disabled', true);
                }
            }
        });
    }

    enableBonusProductSelection();
    enableAddAfterBonusColorSelection();
}

class QuickView {
    constructor () {
        this.quickImpressionSender = require('./../analytics/helpers/quickImpressions');
    }

    run () {
        this.showQuickview();
        this.beforeUpdateAttribute();
        this.updateAttribute();
        this.updateAddToCart();
        this.updateAvailability();
        this.observeQuickBuy();

        this.currentWishlistButton = null;
    }

    showQuickview () {
        let _self = this;
        $('body').on('click', '.quickview', function (e) {
            e.preventDefault();
            const pid = $(this).data('pid');
            const selectedValueUrl = $(this).attr('href') || $(this).data('url');
            const modalClass = typeof $(this).data('modal-class') === 'string' ? $(this).data('modal-class').split(',') : [];
            const productUrl = selectedValueUrl.replace('Product-ShowQuickView', 'Product-Show');
            const modal = newModalFromString('', false, ['quickview-modal', 'quickview-modal--tezenis'].concat(modalClass));
            fillModalElement(productUrl, selectedValueUrl, modal);
            $('body').trigger('product:triggerProductDetails', pid);

            _self.currentWishlistButton = $(this);
        });
    }

    beforeUpdateAttribute () {
        $('body').on('product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    }

    updateAttribute () {
        const _self = this;

        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.tingle-modal.tingle-modal--visible .product-quickview > .bundle-items').length) {
                $('.tingle-modal.tingle-modal--visible').find(response.container).data('pid', response.data.product.id);
                $('.tingle-modal.tingle-modal--visible').find(response.container)
                    .find('.product-id').text(response.data.product.id);
            } else if ($('.set-items').length) {
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.tingle-modal.tingle-modal--visible .product-quickview').data('pid', response.data.product.id);
                $('.tingle-modal.tingle-modal--visible .full-pdp-link')
                    .attr('href', response.data.product.selectedProductUrl);
            }

            _self.quickImpressionSender.pushNewProduct(response);
        });

        $('body').on('wishlist:changedSuccessfully', function (e, response) {
            if (!_self.currentWishlistButton) {
                return;
            }

            // We are in plp and we are handling the change of the quickview's wishlist preference
            let pid = _self.currentWishlistButton.closest('.product, .product-quickview, .product-info, .product-detail').attr('data-pid');

            if (response.pid === pid) {
                // Chane heart icon
                if (response.isAdding) {
                    // Added
                    _self.currentWishlistButton.parent().find('.wishlistTile').addClass('added');
                } else {
                    // Removed
                    _self.currentWishlistButton.parent().find('.wishlistTile').removeClass('added');
                }
            }
        });
    }

    updateAddToCart () {
        $('body').on('product:updateAddToCart', function (e, response) {
            if (!response.product.available || response.product.comingSoon) {
                $('button.add-to-cart, button.add-to-cart-global').data('disabled', true);
            } else if (!response.product.readyToOrder) {
                $('button.add-to-cart, button.add-to-cart-global').removeAttr('disabled');
            } else {
                $('button.add-to-cart, button.add-to-cart-global').data('disabled', false);
            }
        });
    }

    updateAvailability () {
        $('body').on('product:updateAvailability', function (e, response) {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .addClass('text-medium-gray')
                .removeClass('text-brand-blue')
                .removeClass('text-brand-green')
                .empty()
                .html(response.message);

            if (response.product.available) {
                $('.product-availability', response.$productContainer)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .addClass('text-brand-green')
                    .removeClass('text-brand-blue')
                    .removeClass('text-medium-gray');
            } else if (response.product.comingSoon) {
                $('.product-availability', response.$productContainer)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .addClass('text-brand-blue')
                    .removeClass('text-brand-green')
                    .removeClass('text-medium-gray');
            }

            var dialog = $(response.$productContainer)
                .closest('.tingle-modal');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                var allAvailable = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg', dialog).empty().addClass('text-medium-gray')
                    .html(allReady ? response.message : response.resources.info_selectforstock);

                if (allAvailable) {
                    $('.global-availability .availability-msg', dialog).addClass('text-brand-green').removeClass('text-medium-gray');
                }
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .addClass('text-medium-gray')
                    .empty()
                    .html(response.message);

                if (response.product.available) {
                    $('.global-availability', dialog)
                        .data('ready-to-order', response.product.readyToOrder)
                        .data('available', response.product.available)
                        .find('.availability-msg')
                        .addClass('text-brand-green')
                        .removeClass('text-medium-gray');
                }
            }
        });
    }

    observeQuickBuy () {
        $('body').off('click', '.quick-buy-sizes-item');
        $('body').on('click', '.quick-buy-sizes-item', function (e) {
            e.preventDefault();
            if ($(this).hasClass('disable') || !$(this).data('variant')) {
                return false;
            }

            const $productContainer = $(e.currentTarget).closest('.product');
            let listingType = $productContainer.find('.analytics.productListingItem').data('visualization_type');
            var url = $(this).data('variant');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                success: function (response) {
                    $.spinner().stop();
                    // For minicart promo carousel
                    var promotionId = $productContainer.find('.promotion-info-plp').data('promo-id') || false;

                    if (response.product.available && !response.product.comingSoon) {
                        const isOrderAgainProduct = $productContainer.closest('.js-orderAgain-cartCarousel__list').length > 0;
                        addToCartFromListing(listingType, response.product.id, promotionId, $productContainer, isOrderAgainProduct);
                    }
                    if ($('.page').data('action') === 'Cart-Show') {
                        $('body').on('product:afterAddToCart', () => {
                            if (history.scrollRestoration) {
                                history.scrollRestoration = 'manual';
                            }
                            location.reload();
                        });
                    }
                },
                error: function (err) {
                    console.error('ErrorCase: ' + err.message);
                    $.spinner().stop();
                }
            });
        });
    }
};

const quickView = new QuickView();
export default quickView;
